import api from './api'
import jwtDecode from 'jwt-decode'

const ACCESS_TOKEN_STORAGE_KEY = 'accessToken'
const USER_STORAGE_KEY = 'user'

function getToken() {
  const token = localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)

  if (!token) {
    return {}
  }

  return {
    encoded: token,
    decoded: jwtDecode(token)
  }
}

function verifyToken() {
  const { encoded, decoded } = getToken()
  if (!encoded || !decoded || !decoded.exp) {
    return false
  }

  if (Date.now() / 1000 > decoded.exp) {
    return false
  }

  api.accounts.setToken(encoded)
  api.billing.setToken(encoded)
  api.nodes.setToken(encoded)

  return true
}

const getProfile = () => api.accounts.get('users/me').then(({ data }) => data)

function updateProfile({ displayName, billingAddress, entityType }) {
  const params = { displayName, billingAddress, entityType }
  if (
    !billingAddress.address &&
    !billingAddress.zipCode &&
    !billingAddress.state
  ) {
    delete params.billingAddress
  }
  return api.accounts.put('users/me', params).then(({ data }) => data)
}

const getNonce = () =>
  api.auth
    .post('users/me/nonce', undefined, {
      headers: {
        authorization: `Bearer ${getToken().encoded}`
      }
    })
    .then(({ data }) => data)

const sendVerificationEmail = email =>
  api.auth.post(`users/${email}/verification`).then(({ data }) => data)

const signup = ({ email, password, displayName, billingAddress, entityType }) =>
  api.auth
    .post('signup', {
      email,
      password,
      displayName,
      billingAddress,
      entityType
    })
    .then(({ data }) => data)

const verify = ({ email, token }) =>
  api.auth.put(`users/${email}/verification/${token}`).then(({ data }) => data)

const resetPassword = email =>
  api.auth.post(`users/${email}/password/reset`).then(({ data }) => data)

const setPassword = ({ email, token, newPassword }) =>
  api.auth
    .put(`users/${email}/password/${token}`, { newPassword })
    .then(({ data }) => data)

const login = (username, password) =>
  api.auth
    .post('login', undefined, { auth: { username, password } })
    .then(function ({ data }) {
      api.accounts.setToken(data.accessToken)
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, data.accessToken)
      localStorage.setItem(
        USER_STORAGE_KEY,
        JSON.stringify(jwtDecode(data.accessToken))
      )
      return data
    })

function isAdmin() {
  try {
    const user = JSON.parse(localStorage.getItem(USER_STORAGE_KEY))
    return user.isAdmin
  } catch (err) {
    return false
  }
}

function impersonator() {
  const token = getToken()
  return token && token.decoded && token.decoded.impersonator
}

function logout() {
  localStorage.clear()
}

export default {
  login,
  signup,
  logout,
  isAdmin,
  verify,
  getNonce,
  getProfile,
  verifyToken,
  setPassword,
  impersonator,
  updateProfile,
  resetPassword,
  sendVerificationEmail
}
